import React from 'react';
import {
  Box,
  IconButton,
  Typography,
  Chip,
  Button,
  Tooltip,
  CardActions,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import { useAppSelector } from 'renderer/shared/state/hooks';
import { selectUserId } from 'renderer/features/auth/state/userSelectors';
import { PaymentMethod } from '../schemas/paymentMethods.schemas';
import { useEditPaymentMethodMutation } from '../services/paymentMethods.endpoints';

interface PaymentMethodCardProps {
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  card: PaymentMethod;
}

const PaymentMethodCard: React.FC<PaymentMethodCardProps> = ({
  card,
  onEditIconClick,
  onDeleteIconClick,
}) => {
  console.log('PaymentMethodCard card', card);
  const [updateCard, { isLoading }] = useEditPaymentMethodMutation();
  const userId = useAppSelector(selectUserId);

  const expiry = `${String(card.expirationMonth).padStart(2, '0')}${String(
    card.expirationYear,
  ).slice(-2)}`;

  console.log('expiry', expiry);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        width: '100%',
      }}
    >
      <Box
        sx={{
          transform: 'scale(0.95)',
          transformOrigin: 'top left', // or 'center' depending on layout
          width: 'fit-content',
        }}
      >
        <Cards
          number={`•••• •••• •••• ${card.last4}`}
          preview
          name={card.billingAddress.nameOnCard || 'Cardholder'}
          expiry={expiry}
          issuer={card.cardType}
          cvc="•••"
          focused="number"
        />
      </Box>

      <CardActions sx={{ justifyContent: 'space-between', width: 300 }}>
        {card.default ? (
          <Chip label="Default" size="small" color="info" />
        ) : (
          <Button
            size="small"
            variant="outlined"
            color="inherit"
            disabled={isLoading}
            onClick={() =>
              updateCard({
                id: card._id,
                payload: { userId, default: true },
              })
            }
          >
            Make Default
          </Button>
        )}

        <Box>
          <Tooltip title="Edit">
            <IconButton onClick={onEditIconClick} color="inherit">
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton onClick={onDeleteIconClick} color="inherit">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </CardActions>
    </Box>
  );
};

export default PaymentMethodCard;
